/** Storage cost of a project or an organization, from the latest bucket inventory (N19–N21). Staff only. */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, unwrap } from './client';
import type { components } from './schema';

export type ProjectCost = components['schemas']['ProjectCost'];
export type OrganizationCost = components['schemas']['OrganizationCost'];

const P = (id: string) => ({ params: { path: { public_id: id } } });

export async function projectCost(projectId: string): Promise<ProjectCost> {
  return unwrap(await api.GET('/api/projects/{public_id}/cost', P(projectId)));
}
export async function refreshProjectCost(projectId: string): Promise<ProjectCost> {
  return unwrap(await api.POST('/api/projects/{public_id}/cost/refresh', P(projectId)));
}
export async function organizationCost(orgId: string): Promise<OrganizationCost> {
  return unwrap(await api.GET('/api/organizations/{public_id}/cost', P(orgId)));
}

export function useProjectCost(projectId: string | undefined) {
  return useQuery({ queryKey: ['cost', 'project', projectId], queryFn: () => projectCost(projectId!), enabled: !!projectId });
}
export function useRefreshProjectCost(projectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => refreshProjectCost(projectId),
    onSuccess: (data) => {
      qc.setQueryData(['cost', 'project', projectId], data);
      void qc.invalidateQueries({ queryKey: ['cost', 'organization'] });
    },
  });
}
export function useOrganizationCost(orgId: string | undefined) {
  return useQuery({ queryKey: ['cost', 'organization', orgId], queryFn: () => organizationCost(orgId!), enabled: !!orgId });
}
